import { Component, OnInit, EventEmitter } from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { PackageService } from '../../common/package.service';

@Component({
  selector: 'guest-membership-form',
  templateUrl: './guest-membership-form.component.html',
  styleUrls: ['./guest-membership-form.component.css', '../../app.component.css'],
  providers: [PackageService],
})
export class GuestMembershipFormComponent implements OnInit {

 packageForm: any;
 eventId: any;
 packageId: any;
 package: any;
 spinner: boolean = false;

 constructor(private formBuilder: FormBuilder, private packageService: PackageService, private activatedRoute: ActivatedRoute){
  this.packageForm = this.formBuilder.group({
   'id': [''],
   'name': ['', Validators.required],
   'price': ['', Validators.required],
   'quantity': ['', Validators.required],
   'freeAttendeesCount': ['', Validators.required],
   'extraAttendeePrice': ['', Validators.required],
  });
  this.package = this.packageForm.value;
  this.activatedRoute.queryParams.subscribe((params: Params) => {
   this.eventId = params.id;
  });
 }

 ngOnInit() {
 }

 onSave = new EventEmitter();

 savePackage() {
  this.spinner = true;
  if(this.packageForm.valid)
  {
   var params = this.packageForm.value;
   params.eventId = this.eventId;
   //this.packageService.saveGuestPackage(params).subscribe(
   // response => {
   //  this.spinner = false;
   //  if(response.status)
   //  this.onSave.emit();
   // },
   // error => {
   //  this.spinner = false;
   // }
   //);
  }
 }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/guest-membership-form/guest-membership-form.component.ts